export default {
  // 模块名称
  personCm: {
    // 按钮类
    button: {
      create: 'Create',
      delete: 'Delete',
      start: 'Enabled',
      disable: 'Disabled',
      query: 'Query',
      reset: 'Reset',
      confirm: 'Confirm',
      cancel: 'Cancel',
      save: 'Save',
      allDay: 'AllDay'
    },
    // 文字标签类
    label: {
      name: 'Name',
      state: 'Status',
      time: 'Time',
      people: 'People',
      type: 'Type',
      groups: 'NameGroups',
      whiteList: 'White list',
      blackList: 'Black list',
      hitAlarm: ' HitAlarm',
      nohitAlarm: 'UnhitAlarm',
      select: 'Select',
      threshold: 'Threshold',
      alarmType: 'AlarmType',
      object: 'Object',
      No: 'No',
      groupName: 'GroupName',
      group: 'Group',
      checkAll: 'Check all',
      Monday: 'Monday',
      Tuesday: 'Tuesday',
      Wednesday: 'Wednesday',
      Thursday: 'Thursday',
      Friday: 'Friday',
      Saturday: 'Saturday',
      Sunday: 'Sunday',
      nodata: 'No Data'
    },
    // 提示类
    placeholder: {
      modification: 'Edit',
      delete: 'Delete',
      disable: 'Disabled',
      enabled: 'Enabled',
      name: 'Enter name',
      state: 'Select status',
      unlimited: 'Unlimited',
      peopleName: 'Please enter the name of the list group'
    },
    // 消息类
    message: {
      unableDelete: 'Task enabled, cannot be deleted',
      deleteWarn:
        'This action permanently deletes the task. Do you want to continue?',
      deleteOk: 'delete success',
      deleteNo: 'delete fail',
      deleteStarting:
        'The selected task has an enabled task and cannot be deleted!',
      startWarn:
        'This operation will enable the deployment task. Do you want to continue?',
      disableWarn:
        'This operation will disable the deployment task. Do you want to continue?',
      starting: 'The selected task has enabled tasks!',
      disableing: 'The selected task has disabled tasks!',
      someStart:
        'This operation will batch enable the task. Do you want to continue?',
      someDisable:
        'This action disables the task in bulk. Do you want to continue?',
      someDelete:
        'This action will batch delete the task. Do you want to continue?',
      batchStart: 'You have not selected the deployment task to enable in bulk', //批量启用提醒
      batchDisable:
        'You have not selected a deployment task to disable in bulk', //批量禁用提醒
      batchDelete:
        'You have not selected the deployment task to be deleted in bulk', //批量删除提醒
      cameraGroup: 'Select the control camera unit',
      createOk: 'The new deployment mission was successful',
      choseType: 'First choose the layout control type',
      groupList: 'Select control list group',
      editOk: 'Modified deployment mission successfully',
      choseTypes: 'Please select the layout type',
      alarmType: 'Please select the alarm type',
      choseObject: 'Please select the control object',
      choseTime: 'Please select the control time',
      length: 'The length is between 1 and 50 characters',
      value:
        'The illegal name shall be a combination of Chinese, English and Numbers',
      controlDate: 'Please select the date of deployment',
      controlTime: 'Please select the time period of control'
    },
    // 标题类
    title: {
      remind: 'Warning',
      successStart: 'Enable success',
      successDisable: 'Disable success',
      selectTime: 'Control time selection',
      selectPeople: 'Selection of control personnel group',
      edit: 'Edit',
      groupList: 'Please select the list group',
      startTime: 'StartTime',
      endTime: 'EndTime',
      to: 'To'
    }
  }
}
